export enum WorkspaceType {
    SceneRecognition = 'Scene Recognition',
    AnomalyRecognition = 'Anomaly Recognition',
    Segmentation = 'Segmentation',
    ObjectDetection = 'Object Detection'
}

export enum HotKeysMode {
    None = 'None',
    Workspace = 'Workspace',
    ClassList = 'ClassList',
    // These two are currently only used in the segmentation workspace
    ClassSelector = 'ClassSelector',
    ImageLibrary = 'ImageLibrary',
    // Special components that require text input
    WorkspaceInput = 'WorkspaceInput',
    WorkspaceAnnotator = 'WorkspaceAnnotator'
}



// WEBPACK FOOTER //
// ./src/providers/workspace_enums.ts